var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller("HelppageController", [
    "$scope", "$document","helpPageService",
    function ($scope, $document, helpPageService) {
        $scope.list = [];
        $scope.checkDataType = function (content) {
            return typeof (content);

        }
        $scope.getHelpPageContent = function () {
            helpPageService.getHelpPageContent().then(function (response) {
                if (response && response.data) {
                    $scope.helpPage = response.data;
                    if (response.data != null && response.data != undefined && response.data.length > 4) {
                        $scope.helpPageTableContent = response.data[5];
                    }
                   
                }
            });
        }
        $scope.getHelpPageContent();

       
    }


]);
